module.exports = __webpack_public_path__ + "img/Animals-low.a3db56c1.jpg";